document.addEventListener("submit", async function (event) {
  const form = event.target;

  if (!form.matches('form[action*="/cart/add"]')) return;

  event.preventDefault();

  const formData = new FormData(form);

  // Cart drawer ke sections bhi update karwao
  formData.append("sections", "cart-drawer,cart-icon-bubble");
  formData.append("sections_url", window.location.pathname);

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest"
      },
      body: formData
    });

    const data = await response.json();

    if (!response.ok) {
      console.error(data);
      return;
    }

    // Cart drawer find karo
    const cartDrawer = document.querySelector("cart-drawer");

    if (cartDrawer && typeof cartDrawer.renderContents === "function") {
      cartDrawer.renderContents(data);
      cartDrawer.open();
    } else {
      // Fallback
      const drawer = document.querySelector(
        "#CartDrawer, .cart-drawer, .drawer"
      );

      if (drawer) {
        drawer.classList.add("active", "animate", "open");
      }
    }

  } catch (error) {
    console.error("Add to cart error:", error);
  }
});
